import { useT } from "@/i18n/LanguageContext";

export default function PromoBanner() {
  const { t } = useT();
  return (
    <div data-testid="promo-banner" className="fixed top-0 inset-x-0 z-[60] bg-red-700 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 h-8 flex items-center justify-center text-center">
        <p className="text-[12px] md:text-[13px] font-medium tracking-tight leading-none">
          {t("promo.banner")}
        </p>
      </div>
    </div>
  );
}
